import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/app-tw.generated.css'
import './index.css'
import './styles/mobile.css'
import App from './App.jsx'
import { initTheme } from './utils/theme'

initTheme()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
